import MapView from '$blocks/AppHome/components/MapView'
import VisitorCard from '$blocks/AppHome/components/VisitorCard'
import VisitorList from '$blocks/AppHome/components/VisitorList'
import Loading from '$components/Loading'
import { useRouteSummary } from '$contexts/RouteContext/hooks'
import { getTenantVisitorsByLocation } from '$services/api'
import { useRequest } from 'ahooks'
import { useEffect, useState } from 'react'

const tabs = [
  { label: 'Map', value: 'map' },
  { label: 'Countries', value: 'country' }
]

const VisitorByLocation = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].value)

  const { route } = useRouteSummary()
  const { tenantId } = route.params

  const { loading, data, run } = useRequest(getTenantVisitorsByLocation, {
    manual: true
  })

  const { data: visitors = [] } = { ...data }

  useEffect(() => {
    if (!tenantId) return
    run()
  }, [tenantId, run])

  if (loading) return <Loading />

  return (
    <VisitorCard
      header="Locations"
      tabs={tabs}
      onChangeTab={setActiveTab}
      currentTab={activeTab}
    >
      {activeTab === tabs[0].value && <MapView data={visitors} />}

      {activeTab === tabs[1].value && (
        <VisitorList title="Country" data={visitors} />
      )}
    </VisitorCard>
  )
}

export default VisitorByLocation
